import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Box,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Avatar,
    Divider,
} from '@mui/material';
import {
    Hotel,
    AccountCircle,
    Logout,
    Dashboard as DashboardIcon,
    AddCircle,
    Circle,
    People,
    Assessment,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function Navbar({ user, onLogout, wsConnected }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const roleLabels = {
        ADMIN: { label: 'Administrator', color: '#1a237e' },
        MANAGER: { label: 'Manager', color: '#0d47a1' },
        MAID: { label: 'Cameristă', color: '#2e7d32' },
    };

    const roleConfig = roleLabels[user.role] || roleLabels.MAID;

    return (
        <AppBar
            position="sticky"
            sx={{
                background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            }}
        >
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
                    onClick={() => navigate('/')}
                >
                    <Hotel sx={{ fontSize: 32 }} />
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            fontFamily: '"Playfair Display", serif',
                            letterSpacing: 0.5,
                            display: { xs: 'none', sm: 'block' },
                        }}
                    >
                        Hotel Management
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Chip
                        icon={<Circle sx={{ fontSize: '12px !important', color: wsConnected ? '#4caf50' : '#f44336' }} />}
                        label={wsConnected ? 'Live' : 'Offline'}
                        size="small"
                        sx={{
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            color: '#fff',
                            display: { xs: 'none', md: 'flex' },
                        }}
                    />

                    <Chip
                        label={roleConfig.label}
                        size="small"
                        sx={{
                            backgroundColor: roleConfig.color,
                            color: '#fff',
                            fontWeight: 600,
                        }}
                    />

                    <IconButton color="inherit" onClick={(e) => setAnchorEl(e.currentTarget)}>
                        <Avatar
                            sx={{
                                width: 36,
                                height: 36,
                                backgroundColor: 'rgba(255,255,255,0.2)',
                                fontSize: '0.9rem',
                            }}
                        >
                            {user.firstName?.[0]}{user.lastName?.[0]}
                        </Avatar>
                    </IconButton>
                </Box>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    PaperProps={{
                        sx: { borderRadius: 2, minWidth: 200, mt: 1 },
                    }}
                >
                    <Box sx={{ px: 2, py: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            {user.firstName} {user.lastName}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {user.email}
                        </Typography>
                    </Box>
                    <Divider />
                    <MenuItem onClick={() => { setAnchorEl(null); navigate('/'); }}>
                        <ListItemIcon><DashboardIcon fontSize="small" /></ListItemIcon>
                        <ListItemText>Dashboard</ListItemText>
                    </MenuItem>
                    {(user.role === 'ADMIN' || user.role === 'MANAGER') && (
                        <MenuItem onClick={() => { setAnchorEl(null); navigate('/add-room'); }}>
                            <ListItemIcon><AddCircle fontSize="small" /></ListItemIcon>
                            <ListItemText>Adaugă cameră</ListItemText>
                        </MenuItem>
                    )}
                    {(user.role === 'ADMIN' || user.role === 'MANAGER') && (
                        <MenuItem onClick={() => { setAnchorEl(null); navigate('/reports'); }}>
                            <ListItemIcon><Assessment fontSize="small" /></ListItemIcon>
                            <ListItemText>Rapoarte</ListItemText>
                        </MenuItem>
                    )}
                    {user.role === 'ADMIN' && (
                        <MenuItem onClick={() => { setAnchorEl(null); navigate('/admin'); }}>
                            <ListItemIcon><People fontSize="small" /></ListItemIcon>
                            <ListItemText>Gestionare utilizatori</ListItemText>
                        </MenuItem>
                    )}
                    <Divider />
                    <MenuItem onClick={onLogout}>
                        <ListItemIcon><Logout fontSize="small" color="error" /></ListItemIcon>
                        <ListItemText sx={{ color: 'error.main' }}>Deconectare</ListItemText>
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;